import { computed, ref, } from 'vue';
import { defineStore } from 'pinia';
import { FormDataRequestMap } from '@/form/form-data/FormDataRequestMap';
import { requestMapService } from '@/services/request-map';
import { PostRequestMap } from '@/service-data/request-map/PostRequestMap';
import { CancelItem } from '@/service-data/request-map/CancelItem';
import { GetBrgMapAddressList } from '@/service-data/request-map/GetBrgMappAddressList';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
/** 초기화 (reset) 필요 없는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 세부지명 요청
export const piniaRequestMap = defineStore('requestMap', () => {
    // INIT
    // STATE
    /** 지역 코드 리스트 */
    const areaList = ref([]);
    /** 바로고 db 출력 주소 리스트 */
    const addressList = ref([]);
    /** 검색 */
    const filterOption = ref({
        areaType: '',
        pageNumber: 1,
        searchWord: {
            /** 검색유형 */
            field: '',
            /** 검색어 */
            value: '',
        },
        pageSizeType: pageSizeEnum['50'],
    });
    /** 리스트 */
    const itemList = ref([]);
    /** 페이지네이션 */
    const paginationData = ref({});
    /** 등록 폼데이터 */
    const formData = ref(new FormDataRequestMap());
    /** 폼데이터 비교용 */
    const originFormData = ref(new FormDataRequestMap());
    // GETTER
    /** 게시글 수 */
    const getterItemTotalCount = computed(() => paginationData.value.total || 0);
    const getterLatlong = computed(() => {
        try {
            return formData.value.selectedAddress?.data?.location;
        }
        catch (error) {
            console.log('[getterLatlong] 오류', error);
            return {
                latitude: '',
                longitude: '',
            };
        }
    });
    /** 지역 코드 리스트를 {name: description} 형태로 변환 */
    const getterAreaListForObject = computed(() => areaList.value.reduce((acc, item) => {
        acc[item.name] = item.description;
        return acc;
    }, {}));
    /** 선택한 주소의 풀 주소 문자열 // 서울시 구로구 개봉로.... */
    const selectedAddressFullString = computed(() => '11');
    // METHOD
    /**
     * 바로고 맵데이터 조회
     */
    const getBrgMapAddressList = async () => {
        const serviceData = new GetBrgMapAddressList({
            ...formData.value,
        });
        const response = await requestMapService.getBrgMapAddressList(serviceData);
        addressList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 지역 조회
     */
    const getAreaList = async () => {
        const response = await requestMapService.getAreaList();
        areaList.value = response.data;
    };
    /**
     * 리스트 조회
     */
    const getItemList = async () => {
        const response = await requestMapService.getItemList({
            pageNumber: filterOption.value.pageNumber,
            pageSize: filterOption.value.pageSizeType,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 단건 등록
     */
    const createItem = async () => {
        const serviceData = new PostRequestMap(formData.value);
        const response = await requestMapService.createItem(serviceData);
        return response;
    };
    /**
     * 단건 취소
     */
    const cancelItem = async (id) => {
        const serviceData = new CancelItem(id);
        const response = await requestMapService.cancelItem(serviceData);
        return response;
    };
    /**
     * 폼 데이터 셋팅
     */
    const setFormData = (_formData) => {
        // res to form
        formData.value = new FormDataRequestMap(_formData);
        originFormData.value = new FormDataRequestMap(_formData);
    };
    /**
     * 이벤트 전파용 publish
     */
    const publishUpdateMapPosition = () => {
        console.log('[publishUpdateMapPosition]');
    };
    return {
        areaList,
        addressList,
        formData,
        originFormData,
        filterOption,
        itemList,
        paginationData,
        getBrgMapAddressList,
        getItemList,
        getAreaList,
        cancelItem,
        createItem,
        setFormData,
        getterItemTotalCount,
        getterLatlong,
        selectedAddressFullString,
        publishUpdateMapPosition,
        getterAreaListForObject,
    };
});
